import { ConcreteEncodable } from "./ConcreteEncodable";

import { TradingCalendarRunImplEncoder } from "../../encoder/TradingCalendarRunImplEncoder";

import * as CubiqTS from "../../index";
import { TradingCalendarRun } from "../TradingCalendarRun";

export class TradingCalendarRunImpl extends ConcreteEncodable implements TradingCalendarRun {
  public static enType: string = "com.bcdfx.model.calendar.TradingCalendarRunImpl";

  /*FID=1*/
  public baseCcyCd: string;
  /*FID=2*/
  public nonBaseCcyCd: string;
  /*FID=3*/
  public product: CubiqTS.Product;
  /*FID=4*/
  public valueDates: Array<CubiqTS.TenorToValueDate> | null = null;
  /*FID=5*/
  public ndfValueDates: Array<CubiqTS.TenorToValueAndFixingDate> | null = null;
  /*FID=6*/
  public tradeDateRollDate: CubiqTS.StandardDate | null = null;
  /*FID=7*/
  public tradeDateRollTime: CubiqTS.StandardTime | null = null;
  /*FID=8*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TradingCalendarRunImplEncoder.Instance;
    this.setEncodableType(TradingCalendarRunImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TradingCalendarRunImpl[" +
      "baseCcyCd=" +
      this.baseCcyCd +
      "nonBaseCcyCd=" +
      this.nonBaseCcyCd +
      "product=" +
      this.product +
      "valueDates=" +
      this.valueDates +
      "ndfValueDates=" +
      this.ndfValueDates +
      "tradeDateRollDate=" +
      this.tradeDateRollDate +
      "tradeDateRollTime=" +
      this.tradeDateRollTime +
      "errors=" +
      this.errors +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
